
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14.35 14.511"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_30610","data-name":"Path 30610","d":"M3.015 11.927h1.364a3.019 3.019 0 005.663 0h1.3m2.062-.35a1.19 1.19 0 01-.846.35H1.796a1.228 1.228 0 01-.255-.027 1.192 1.192 0 01-.909-1.419v-.005l1.282-5.765a5.223 5.223 0 0110.133-.263l1.68 6.053a1.208 1.208 0 01.023.235 1.193 1.193 0 01-.347.841z","fill":"none","stroke":"#262626","stroke-miterlimit":"10","stroke-width":"1.2"}})])
          )
        }
      }
    